
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { TopicFilter } from './TopicFilter';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  searchLoading?: boolean;
  topicFilter?: string;
  onTopicFilterChange?: (topic: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  searchLoading = false,
  topicFilter = 'all',
  onTopicFilterChange = () => {}
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
      <div className="flex items-center space-x-2 flex-1">
        <Search className="h-5 w-5" />
        <Input
          placeholder="Search documents..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="max-w-md"
        />
        {searchLoading && <div className="text-sm text-muted-foreground">Searching...</div>}
      </div>
      
      <TopicFilter value={topicFilter} onChange={onTopicFilterChange} />
    </div>
  );
};
